module.exports = __webpack_public_path__ + "img/10.b9639434.jpg";